goog.provide("shadow.js.shim.module$src$svg$editor$emoji$heart_svg$default");
shadow.js.shim.module$src$svg$editor$emoji$heart_svg$default = shadow.js.shim.module$src$svg$editor$emoji$heart_svg.default;
